<template>
  <div class="step-connected step-stagger">
    <h1 class="step-heading" dir="auto">חשבונות מחוברים</h1>

    <div class="accounts-list">
      <div
        v-for="(account, index) in accounts"
        :key="index"
        class="account-card"
      >
        <div class="account-bank-row">
          <span class="account-bank-name">{{ account.bankName }}</span>
        </div>
        <div class="account-divider" />
        <div class="account-details">
          <span class="account-holder">{{ account.accountName }}</span>
          <span class="account-number">{{ account.accountNumber || account.idNumber }}</span>
        </div>
      </div>
    </div>

    <div class="cta-area">
      <CtaButton
        :text="'להוסיף חשבון נוסף'"
        @click="$emit('add-another')"
      />
      <button class="outlined-button" @click="$emit('done')">
        סיימתי
      </button>
    </div>
  </div>
</template>

<script>
import CtaButton from './CtaButton.vue';

export default {
  name: 'StepConnectedAccounts',
  components: { CtaButton },
  props: {
    accounts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.step-connected {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 27px;
}

.step-heading {
  font-family: 'SimplerProAlte', sans-serif;
  font-size: 32px;
  line-height: 36px;
  font-weight: 900;
  font-style: normal;
  color: #205441;
  text-align: center;
  margin: 0 auto 32px;

  @media (max-width: 500px) {
    font-size: 26px;
    line-height: 32px;
  }
}

.accounts-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.account-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 19px;
  padding: 20px;
}

.account-bank-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.account-bank-name {
  font-family: 'SimplerPro', sans-serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #205441;
}

.account-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 16px 0;
}

.account-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.account-holder {
  font-family: 'SimplerPro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #205441;
}

.account-number {
  font-family: 'SimplerPro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #205441;
}

.cta-area {
  margin-top: auto;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.outlined-button {
  width: 100%;
  height: 67px;
  background: #f9f7ed;
  border: 1px solid #4868ff;
  border-radius: 16px;
  box-shadow: 0px 4px 13.1px rgba(0, 0, 0, 0.09);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'SimplerPro', sans-serif;
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: #4868ff;
  transition: opacity 0.2s ease, transform 0.15s ease;

  &:active {
    transform: scale(0.97);
  }
}
</style>
